import { useState } from 'react';
import { Bar } from '../components/ui/Bar.jsx';
import { Btn } from '../components/ui/Btn.jsx';
import { Card } from '../components/ui/Card.jsx';
import { C } from '../theme/palette';
import { FS } from '../theme/typo';
import { useInstallation } from './installation';

/**
 * Carte « Installer l'application ».
 *
 * <p>Sur Android et sur ordinateur (Chrome, Edge), le bouton ouvre la
 * proposition d'installation du navigateur. Sur iPhone et iPad, Safari ne
 * propose rien : la carte explique « Partager → Sur l'écran d'accueil ».
 *
 * @returns {JSX.Element} la carte
 */
export function BoutonInstaller() {
  const { proposable, installee, ios, installer } = useInstallation();
  const [refuse, setRefuse] = useState(false);
  const texte = { fontSize: FS.sm, lineHeight: 1.6, color: C.ink };
  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar icon="📲" title="Installer l'application" color={C.teal} />
      <div style={{ padding: '13px 15px' }}>
        {installee ? (
          <div style={texte}>✓ L'application est installée sur cet appareil.</div>
        ) : proposable ? (
          <>
            <div style={{ ...texte, marginBottom: 10 }}>
              Ajoute SwissTech à ton écran d'accueil : elle s'ouvre en plein écran, sans la barre du
              navigateur, et démarre même sans réseau.
            </div>
            <Btn
              label="📲 Installer l'application"
              color={C.teal}
              full
              onClick={async () => {
                const ok = await installer();
                if (!ok) setRefuse(true);
              }}
            />
            {refuse && (
              <div style={{ ...texte, color: C.muted, marginTop: 8 }}>
                Tu pourras installer l'application plus tard depuis cette page.
              </div>
            )}
          </>
        ) : ios ? (
          <div style={texte}>
            Sur iPhone et iPad, ouvre cette page dans Safari, touche <b>Partager</b>{' '}
            <span aria-hidden="true">⎋</span> puis <b>« Sur l'écran d'accueil »</b>. L'application
            s'ouvre ensuite comme les autres, en plein écran.
          </div>
        ) : (
          <div style={texte}>
            Dans le menu de ton navigateur, choisis <b>« Installer l'application »</b> ou{' '}
            <b>« Ajouter à l'écran d'accueil »</b>. Sur un site déjà installé, cette entrée
            n'apparaît plus.
          </div>
        )}
      </div>
    </Card>
  );
}
